import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { IHowdenEnvironment, IPackageJsonWrapper, provideHowdenCore } from '@howdeniberia/core-front';
import packageJson from '../../package.json';
import { ApiConfigurations } from '../environments/api-configurations';
import { environment } from '../environments/environment';
import { AppRoutes } from './app-routing';
import { TeladocService } from './shared/services/api/teladoc.service';
import { TeladocContract } from './shared/services/api/teladocContract';

registerLocaleData(localeEs, 'es');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: TeladocContract, useClass: TeladocService },
    provideRouter(AppRoutes),
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    provideAnimationsAsync(),
    provideHowdenCore({
      environment: environment as IHowdenEnvironment,
      packageJson: packageJson as unknown as IPackageJsonWrapper,
      apiConfigurations: ApiConfigurations
    })
  ]
};
